import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    BillingInfoAutofill as BillingInfoAutofillMutation,
    BillingInfoAutofillVariables as BillingInfoAutofillMutationVariables,
    ContactInfoInput,
} from 'nutshell-graphql-types';

import AUTOFILL_BILLING_INFO from '../mutations/autofill-billing-info.graphql';

export function useAutofillBillingInfo(): {
    autofillBillingInfo: (arg1: ContactInfoInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} {
    const [billingInfoAutofill, {loading: isLoading, error}] = useMutation<
        BillingInfoAutofillMutation,
        BillingInfoAutofillMutationVariables
    >(AUTOFILL_BILLING_INFO);

    return {
        autofillBillingInfo: (input: ContactInfoInput) =>
            billingInfoAutofill({
                variables: {input},
            }),
        isLoading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
}
